import ProductsTable from "./products-table";

export default ProductsTable;
